export default __webpack_public_path__ + "static/media/28-color.25bf2fde.svg";